import I4Detail from './I4Detail';

export default I4Detail;
